module.exports = __webpack_public_path__ + "static/media/W00F0003.9bf96096.svg";